import Thumbnail from './ThumbnailRedux';

export default Thumbnail;